module.exports = __webpack_public_path__ + "img/weather_widget_task.ffefc8e7.png";